import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SplitSdk } from '@splitsoftware/splitio-react';
// services
import { $cookie } from '@tajawal/web-core-sdk-v2/lib/services/cookie.service';
// constants
import { COOKIES } from '../../../constants/cache.constants';
export function useSplitFactory(_a) {
    var authorizationKey = _a.authorizationKey, trafficType = _a.trafficType, _b = _a.features, features = _b === void 0 ? {} : _b, debug = _a.debug;
    return useMemo(function () {
        var splitId = $cookie.get(COOKIES.SPLIT_ID);
        if (!splitId) {
            splitId = uuidv4();
            $cookie.set(COOKIES.SPLIT_ID, splitId);
        }
        var settings = {
            core: {
                authorizationKey: authorizationKey,
                key: splitId,
                trafficType: trafficType
            },
            // @ts-ignore
            features: features,
            debug: debug,
            integrations: [
                {
                    type: 'SPLIT_TO_GOOGLE_ANALYTICS',
                    impressions: true,
                    events: false
                }
            ]
        };
        return SplitSdk(settings);
    }, [authorizationKey, features]);
}
//# sourceMappingURL=useSplitFactory.js.map